import BadgeIndexPage from "lx/badgeIndexPage";

export { BadgeIndexPage };

customElements.define(
  "lx-badge-index-page",
  BadgeIndexPage.CustomElementConstructor
);
